<template>
  <div :class="{ 'dark-mode': isSupplierOne }">
    <template v-if="lengthNumber == 0">
      <LazyDiscoverEmptyActivities
        :name="
          discoverInfo?.name ??
          route.params.slug?.toString().replaceAll('-', ' ')
        "
        :popular-cities="popularCities"
      />
    </template>
    <div
      v-if="lengthNumber > 0 && discoverInfo"
      class="mb-[30px] md:mb-[40px] container"
    >
      <LazyDiscoverHero
        :info="discoverInfo"
        :product-number="lengthNumber"
        @scroll-to-activities="scrollActivities"
      />
    </div>
    <LazyDiscoverCategories
      v-if="
        features.categoryFilter && categories?.length > 3 && lengthNumber > 0
      "
      :category-list="categories.filter((category) => category.title)"
      @scroll-to-activities="scrollActivities"
    />
    <template v-if="lengthNumber > 0">
      <div
        v-for="item in discoverRecommendations"
        :key="item.id"
        class="md:mt-[68px] mt-9 container"
      >
        <LazyDiscoverRecommendation
          :products="item?.products"
          :title="item?.title"
          :reference="item.reference"
          :dark-mode="isSupplierOne"
          @scroll-to-activities="scrollActivities"
        />
      </div>
    </template>

    <div
      v-if="discoverInfo?.slogan?.title && lengthNumber > 0"
      class="mt-[100px] container"
    >
      <LazyDiscoverBanner
        :title="discoverInfo?.slogan?.title"
        :description="discoverInfo?.slogan?.description"
        :image-url="discoverInfo?.images[1]?.url"
        :facets-categories="discoverFacets?.categories"
        @scroll-to-activities="scrollActivities"
      />
    </div>

    <div v-if="lengthNumber > 0" ref="activities">
      <LazyDiscoverActivities
        class="!pt-[80px] container"
        :facets="discoverFacets"
        :dark-mode="isSupplierOne"
        @scroll-to-activities="scrollActivities"
      />
    </div>

    <div
      v-if="recepient?.length >= 3 && lengthNumber > 0"
      class="mt-[200px] container"
    >
      <LazyDiscoverRecipient
        :facets-labels="recepient"
        @scroll-to-activities="scrollActivities"
      />
    </div>

    <div
      v-if="foodAndDrinkRecommendations && lengthNumber > 0"
      class="mt-[70px] container"
    >
      <LazyDiscoverFoodAndDrinkRecommendation
        :products="foodAndDrinkRecommendations?.products"
        :title="foodAndDrinkRecommendations?.title"
        :city-name="discoverInfo.name"
        @scroll-to-activities="scrollActivities"
      />
    </div>
    <div
      v-if="lengthNumber > 0 && discoverInfo?.faq && discoverInfo?.faq.length"
      class="mt-[100px] container"
    >
      <LazyDiscoverFaq :faq-items="discoverInfo?.faq" />
    </div>
    <LazyHomeExplore
      class="!mt-[100px] !mb-[130px] container"
      :popular-cities="popularCities"
    />
  </div>
</template>
<script setup lang="ts">
import { nextTick, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import type { LayoutInfo } from "#custom-types";
import { useAsyncData } from "nuxt/app";
const runtimeConfig = useRuntimeConfig();
const layout = runtimeConfig.public.layout;
const isSupplierOne = ref(false);
isSupplierOne.value = layout.type?.includes("supplier-one") ?? false;
const route = useRoute();
const features = useRuntimeConfig().public.features;
const activities = ref<HTMLElement>();
const { t } = useI18n();
const [
  { data: popularCities },
  { data: info },
  { data: recommendations },
  { data: discoverFacets },
] = await Promise.all([
  useAsyncData<any>("top-cities", () => customFetch(`api/top-cities`)),
  useAsyncData<any>("info", () =>
    customFetch(`api/destinations/${route.params.slug}/info`)
  ),
  useAsyncData<any>("recommendations", () =>
    customFetch(`api/destinations/${route.params.slug}/recommendations`)
  ),
  useAsyncData<any>("reseller-facets", () =>
    customFetch(`api/v2/products/facets?filter[city]=${route.params.slug}`)
  ),
]);

const discoverInfo = info.value;
const site = useSiteConfig();

useSeoMeta({
  ogTitle: `${t("discover.thingsToDoIn")} ${route.params.slug.toString().replaceAll("-", " ")} | ${site.name}`,
  ogImage: discoverInfo.images[0]?.url,
  ogDescription: discoverInfo.overview.description,
  description: discoverInfo.overview.description,
  ogUrl: site.url.replace(/\/+$/, "") + route.fullPath,
});

const discoverRecommendations = recommendations.value?.filter(
  (x) =>
    !(x.reference?.type === "category" && x.reference.id == 10) &&
    x.products.length > 2
);
const foodAndDrinkRecommendations = recommendations.value?.find(
  (recommendation) =>
    recommendation.reference?.type === "category" &&
    recommendation.reference.slug == "food-drink"
);

const lengthNumber = discoverFacets.value?.total_count ?? 0;
const categories = discoverFacets.value.categories;

const recepient = ref();
recepient.value = discoverFacets.value?.attributes
  .find((x) => x.id == 4)
  ?.values?.slice(0, 5);

function scrollActivities() {
  if (
    activities.value &&
    typeof activities.value.scrollIntoView === "function"
  ) {
    activities.value.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  } else {
    console.error("activities is not ready or not a DOM element");
  }
}

onMounted(async () => {
  if (Object.keys(route.query)?.length) {
    await nextTick();

    setTimeout(() => {
      scrollActivities();
    }, 0);
  }
});
</script>

<style scoped lang="scss">
.cards-grid {
  @apply grid grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-3 sm:gap-5 lg:gap-6;
}
.cards-three-grid {
  @apply grid grid-cols-1 md:grid-cols-1 xl:grid-cols-1 gap-3 sm:gap-5 lg:gap-6;
}
</style>
